/**
 *
 * BootProvider
 *
 */

import React, { createContext, useCallback, useMemo, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { SplashScreen } from 'components/layouts';

const BootContext = createContext(null);

const IDLE = 'idle';
const WAITING = 'waiting';
const FINISHING = 'finishing';

const IDLE_WAIT_MS = 300;

function BootProvider({ children }) {
  const pending = useRef(0);
  const [phase, setPhase] = useState(IDLE);

  const sync = useCallback(() => {
    if (pending.current > 0) {
      setPhase(WAITING);

      return;
    }

    window.requestAnimationFrame(() => {
      if (pending.current > 0) return;

      const begin = () => {
        if (pending.current > 0) return;
        setPhase(current => (current === WAITING ? FINISHING : current));
      };

      if (window.requestIdleCallback) window.requestIdleCallback(begin, { timeout: IDLE_WAIT_MS });
      else window.setTimeout(begin, 0);
    });
  }, []);

  const acquire = useCallback(() => {
    pending.current += 1;
    sync();

    return () => {
      pending.current -= 1;
      sync();
    };
  }, [sync]);

  const handleFinished = useCallback(() => {
    setPhase(current => (current === FINISHING ? IDLE : current));
  }, []);

  const value = useMemo(() => ({ acquire }), [acquire]);

  return (
    <BootContext.Provider value={value}>
      {phase !== IDLE && (
        <SplashScreen finishing={phase === FINISHING} onFinished={handleFinished} />
      )}
      {children}
    </BootContext.Provider>
  );
}

BootProvider.propTypes = {
  children: PropTypes.any,
};

export default BootProvider;
export { BootContext };
